import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/close-icon-2.svg'


const _hoisted_1 = { class: "absolute overflow-y-auto top-5 w-[630px] p-6 mx-3 bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100 rounded-lg shadow-lg max-w-md" }
const _hoisted_2 = { class: "flex justify-between border-b border-gray-300 pb-3" }
const _hoisted_3 = { class: "flex flex-col w-11/12" }
const _hoisted_4 = { class: "text-xl leading-[32px] tracking-[0.01rem] text-primary-text-color font-semibold" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "text-base leading-[26px] tracking-[0.01rem] text-[#898790] font-medium pt-4" }
const _hoisted_7 = {
  key: 0,
  class: "text-sm text-red-400 font-medium mt-1"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "text-base leading-[26px] tracking-[0.01rem] text-[#898790] font-medium pt-4" }
const _hoisted_10 = {
  key: 2,
  class: "mt-3"
}
const _hoisted_11 = { class: "text-base leading-[26px] tracking-[0.01rem] text-[#898790] font-medium pt-4" }
const _hoisted_12 = { class: "text-base leading-[26px] tracking-[0.01rem] text-[#898790] font-medium pt-4" }
const _hoisted_13 = {
  key: 0,
  class: "text-sm text-red-400 font-medium mt-1"
}
const _hoisted_14 = {
  key: 3,
  class: "flex w-full overflow-x-auto gap-1 mt-6 whitespace-nowrap scrollable-container"
}
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "flex flex-col gap-2 mt-[36px]" }
const _hoisted_17 = {
  for: "file",
  class: "px-4 py-2 text-[#393840] font-medium rounded-md cursor-pointer transition flex items-center border-2 border-[#393840] w-fit hover:bg-[#F9F8F6]"
}
const _hoisted_18 = {
  key: 0,
  class: "text-sm text-red-400 font-medium mt-1"
}
const _hoisted_19 = { class: "flex justify-end" }
const _hoisted_20 = {
  key: 0,
  class: "w-8 h-8 border-4 border-white border-t-transparent rounded-full animate-spin"
}
const _hoisted_21 = { key: 1 }

import client from "@/utils/axios";
import SelectMenu from "./SelectMenu.vue";
import { ref, computed, watch, reactive } from "vue";
import { errorToast, successToast } from "@/utils/custom-toast";
import { useTranslate } from "@/composables/useTranslate";

type Props = {
  steps: Array<any>;
  termins?: Array<any>;
  isOpen?: boolean;
  project: string | string[];
  phase: number;
  step?: any;
  input?: any;
  groupIndex?: number;
  inputIndex?: number;
  headerTitle: string;
};

type Emits = {
  (event: "toggleModal"): void;
  (event: "refresh"): void;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'AddImageModal',
  props: {
    steps: {},
    termins: {},
    isOpen: { type: Boolean },
    project: {},
    phase: {},
    step: {},
    input: {},
    groupIndex: {},
    inputIndex: {},
    headerTitle: {}
  },
  emits: ["toggleModal", "refresh"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;
const { t } = useTranslate();

const selectedStep = ref<any>(
  props.step
    ? {
        id: props.step.id,
        name: props.step.name,
      }
    : null
);
const selectedInput = ref<any>(
  props.input
    ? {
        id: props.input.id,
        name: props.input.name,
      }
    : null
);
const selectedTermin = ref<any>(null);
const description = ref<any>("");
const files = ref([]);
const isLoading = ref(false);

const handleFileChange = (event: any) => {
  files.value = Array.from(event.target.files);
  imagePreviews.value = files.value.map((file: any) =>
    URL.createObjectURL(file)
  );
};

const imagePreviews = ref<string[]>([]);

const steps = computed(() => {
  let stepsWithImage = props.steps.filter((item: any) =>
    item.inputs.some((input: any) => input.type === "image")
  );
  return [...stepsWithImage, { id: -1, name: "Other" }];
});

const inputs = computed(() => {
  let tempSelectedStep = props.steps.find(
    (item: any) => item.id === selectedStep.value?.id
  );

  return selectedStep.value && selectedStep.value?.id !== -1
    ? tempSelectedStep.inputs
        .filter((item: any) => item.type === "image")
        .map((item: any) => {
          return {
            id: item.id,
            name: item.name,
          };
        })
    : [];
});

const errors = reactive({
  selectedStep: "",
  selectedTermin: "",
  images: "",
});

const validate = () => {
  let isValid = [];
  errors.selectedStep = "";
  errors.selectedTermin = "";

  if (!selectedStep.value) {
    errors.selectedStep = "Please select step!";
    isValid.push(false);
  } else {
    isValid.push(true);
    errors.selectedStep = "";
  }

  if (!selectedTermin.value) {
    errors.selectedTermin = "Please select termin!";
    isValid.push(false);
  } else {
    isValid.push(true);
    errors.selectedTermin = "";
  }

  if (imagePreviews.value.length === 0) {
    errors.images = "Please upload image!";
    isValid.push(false);
  } else {
    isValid.push(true);
    errors.images = "";
  }

  return isValid.filter((item: boolean) => !item).length === 0;
};

const onSubmit = async () => {
  if (!validate()) return;

  isLoading.value = true;

  const formData = new FormData();
  formData.append("isNote", selectedStep.value.id === -1 ? "true" : "false");
  formData.append("terminId", selectedTermin.value.id);

  if (selectedStep.value.id === -1) {
    formData.append("description", description.value);
  } else {
    formData.append("stepId", selectedStep.value.id);
    formData.append("inputId", selectedInput.value.id);
    formData.append(
      "groupIndex",
      props.groupIndex !== undefined && props.groupIndex > -1
        ? props.groupIndex + ""
        : "-1"
    );
    formData.append(
      "inputIndex",
      props.inputIndex !== undefined && props.inputIndex > -1
        ? props.inputIndex + ""
        : "-1"
    );
  }

  files.value.forEach((file, index) => {
    formData.append(`files[${index}]`, file);
  });
  try {
    await client.post(
      `/projects/${props.project}/phase/${props.phase}/add-picture`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    isLoading.value = false;
    successToast("Successfully added images.");
    emits("refresh");
    emits("toggleModal");
  } catch (error: any) {
    isLoading.value = false;
    console.log(error);
    if (error.response && error.response.data) {
      errorToast(t(`phase.${error.response.data}`).value);
      return;
    }
    errorToast(error);
  }
};

watch(
  () => selectedStep.value,
  () => {
    if (!props.input) {
      selectedInput.value = null;
    }
  },
  { immediate: true }
);

let repeatableInputTitle = computed(() => {
  if (props.input) {
    let parentInput = props.step.inputs.find(
      (item: any) => item.id === props.input.parentId
    );

    if (props.input.type === "repeatable_input") {
      let title = `${props.input.repeatableInputNoun} ${
        props.inputIndex || props.inputIndex === 0 ? props.inputIndex + 1 : ""
      }`;
      return `${parentInput ? parentInput.name + " /" : ""} ${title}`;
    }
  }
  return "";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["fixed overflow-y-auto inset-0 bg-black bg-opacity-80 justify-center items-center z-50 transition-opacity duration-300 ease-in-out", `${__props.isOpen ? 'flex' : 'hidden'}`])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h4", _hoisted_4, _toDisplayString(__props.headerTitle), 1),
          _createElementVNode("p", null, _toDisplayString(_unref(repeatableInputTitle)), 1)
        ]),
        _createElementVNode("button", {
          class: "w-1/12 h-4 mt-2 flex justify-center",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('toggleModal')))
        }, [...(_cache[5] || (_cache[5] = [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "Close icon"
          }, null, -1)
        ]))])
      ]),
      _createElementVNode("form", {
        onSubmit: _withModifiers(onSubmit, ["prevent"])
      }, [
        (!__props.input && !__props.step)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("h4", _hoisted_6, _toDisplayString(_unref(t)("phase.which_installation_step")), 1),
              _createElementVNode("div", null, [
                _createVNode(SelectMenu, {
                  modelValue: selectedStep.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedStep).value = $event)),
                  "is-error": !!errors.selectedStep,
                  options: steps.value.map((item)=>{
              return{
                id:item.id,
                name:item.name
              }
            })
                }, null, 8, ["modelValue", "is-error", "options"]),
                (errors.selectedStep)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(errors.selectedStep), 1))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        (!__props.input && !__props.step && inputs.value && inputs.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("h4", _hoisted_9, _toDisplayString(_unref(t)("phase.which_description")), 1),
              _createElementVNode("div", null, [
                _createVNode(SelectMenu, {
                  modelValue: selectedInput.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedInput).value = $event)),
                  options: inputs.value
                }, null, 8, ["modelValue", "options"])
              ])
            ]))
          : _createCommentVNode("", true),
        (selectedStep.value && selectedStep.value.id === -1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("h4", _hoisted_11, _toDisplayString(_unref(t)("phase.which_description")), 1),
              _withDirectives(_createElementVNode("textarea", {
                rows: "4",
                class: "w-full outline-none text-base text-primary-text-color font-normal tracking-[0.01rem] bg-[#F9F8F6] p-3 border border-[#E3E1EA] rounded-[5px] resize-none placeholder:text-primary-text-color",
                placeholder: "Description",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((description).value = $event))
              }, null, 512), [
                [_vModelText, description.value]
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _createElementVNode("h4", _hoisted_12, _toDisplayString(_unref(t)("phase.on_which_termin_picture_taken")), 1),
          _createElementVNode("div", null, [
            _createVNode(SelectMenu, {
              modelValue: selectedTermin.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedTermin).value = $event)),
              "is-error": !!errors.selectedTermin,
              options: __props.termins?.map((item)=>{
                return {
                  id:item.id,
                  name:item.name
                }
              })
            }, null, 8, ["modelValue", "is-error", "options"]),
            (errors.selectedTermin)
              ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(errors.selectedTermin), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        (imagePreviews.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(imagePreviews.value, (src, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "shrink-0 w-[123px] h-[123px]"
                }, [
                  _createElementVNode("img", {
                    src: src,
                    alt: "Uploaded image",
                    class: "shrink-0 object-cover w-[123px] h-[123px] rounded-md"
                  }, null, 8, _hoisted_15)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("label", _hoisted_17, [
            _cache[6] || (_cache[6] = _createElementVNode("svg", {
              width: "15",
              height: "16",
              viewBox: "0 0 15 16",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              _createElementVNode("path", {
                d: "M1.40186 7.59852L6.57257 2.4278C8.11026 0.890114 10.6034 0.890114 12.1411 2.4278C13.6788 3.96549 13.6786 6.45872 12.1409 7.99641L6.17468 13.9626C5.14956 14.9877 3.48778 14.9876 2.46265 13.9625C1.43753 12.9373 1.43728 11.2755 2.4624 10.2503L8.42862 4.28413C8.94118 3.77156 9.77265 3.77156 10.2852 4.28413C10.7978 4.79669 10.7974 5.62752 10.2849 6.14008L5.11414 11.3108",
                stroke: "#393840",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              })
            ], -1)),
            _createTextVNode(" " + _toDisplayString(_unref(t)("global.attach_files")), 1)
          ]),
          _createElementVNode("input", {
            multiple: "",
            class: "hidden",
            type: "file",
            id: "file",
            onChange: handleFileChange
          }, null, 32),
          (errors.images)
            ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(errors.images), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", {
            onClick: onSubmit,
            class: "mt-5 flex items-center justify-center py-3 px-[56px] text-base text-white bg-[#393840] tracking-[0.01rem] font-semibold outline-none rounded-primary-radius border-[2px] border-[#393840] cursor-pointer hover:bg-[#28272c] duration-200"
          }, [
            (isLoading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20))
              : (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_unref(t)("global.save")), 1))
          ])
        ])
      ], 32)
    ])
  ], 2))
}
}

})